export const ForgotTranslations = {
  en: {
    forgot: {
      emailLabel: "Email",
      requiredField: "This information is required.",
      sendCode: "Send Code",
      backToLogin: "Back to login",
      forgotPasswordTitle: "Forgot Password?",
      forgotPasswordDescription: "We will send a code to your email to reset your password.",
    },
  },
  es: {
    forgot: {
      emailLabel: "Correo electrónico",
      requiredField: "Esta información es obligatoria.",
      sendCode: "Enviar código",
      backToLogin: "Volver a iniciar sesión",
      forgotPasswordTitle: "¿Olvidaste tu contraseña?",
      forgotPasswordDescription:
        "Te enviaremos un código a tu correo electrónico para restablecer tu contraseña.",
    },
  },
};
